<template>
  <AgentsInternationalLanding />
</template>

<script setup lang="ts">
definePageMeta({ layout: 'agents' });
</script>
